import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'text-block',
    standalone: true,
    imports: [TranslateModule],
    templateUrl: './text-block.component.html',
    styleUrl: './text-block.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextBlockComponent {
    id = input<string>('');
    text = input.required<string | null | undefined>();

    maxHeight = input<string | undefined>(undefined);
    innerHTML = input<boolean>(false);
}
